module.exports = __webpack_public_path__ + "img/hire-logo.d506ddb0.png";